const signatures = {
    JVBERi0: 'application/pdf',
    R0lGODdh: 'image/gif',
    R0lGODlh: 'image/gif',
    iVBORw0KGgo: 'image/png',
    '/9j/': 'image/jpg',
    UEsDB: 'application/vnd.openxmlformats-officedocument',
};
export const getMimeTypeFromBase64 = (base64String) => {
    for (var s in signatures) {
        if (base64String.indexOf(s) === 0) {
            return signatures[s];
        }
    }
};
export const getMimeTypeFromBase641 = (base64String) => {
    const mimeType = base64String.split(',')[0].split(';')[0].split(':')[1];
    return mimeType;
};
export const convertBase64toBlob = (content, contentType) => {
    contentType = contentType || '';
    var sliceSize = 512;
    var byteCharacters = window.atob(content); //method which converts base64 to binary
    var byteArrays = [];
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);
        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    var blob = new File(byteArrays, 'aa', { type: contentType }); //statement which creates the blob
    return blob;
};
export const convertBase64ToBinary = (dataURI, filename) => {
    const arr = dataURI.split(',');
    var mime = getMimeTypeFromBase641(dataURI);
    var bstr = window.atob(arr[1]);
    var n = bstr.length;
    var u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
};
export const convertToPdfFile = (fileString) => {
    const byteCharacters = atob(fileString);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    return blob;
};
export const convertToFile = (fileString) => {
    const base64Marker = ';base64,';
    const base64Index = fileString.indexOf(base64Marker);
    if (base64Index !== -1) {
        fileString = fileString.substring(base64Index + base64Marker.length);
    }
    const byteCharacters = atob(fileString);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'image/png' });
    return blob;
};
// Files at or under this size open inline in a new tab; larger files are downloaded directly,
// since embedding them as an iframe/data URI becomes unreliable in some browsers past a few MB.
const PDF_PREVIEW_MAX_BYTES = 2 * 1024 * 1024;
export const openOrDownloadBlob = (blob, fileName, title = fileName) => {
    const url = URL.createObjectURL(blob);
    const download = () => {
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    // Only the browser's native PDF handler gets an inline preview; active HTML/SVG downloads stay out of the portal origin.
    if (blob.type !== 'application/pdf' || blob.size > PDF_PREVIEW_MAX_BYTES) {
        download();
    }
    else {
        const pdfWindow = window.open();
        if (!pdfWindow) {
            download();
        }
        else {
            pdfWindow.opener = null;
            pdfWindow.document.title = title;
            const frame = pdfWindow.document.createElement('iframe');
            frame.title = title;
            frame.width = '100%';
            frame.height = '90%';
            frame.referrerPolicy = 'no-referrer';
            frame.src = url;
            const fallback = pdfWindow.document.createElement('a');
            fallback.href = url;
            fallback.download = fileName;
            fallback.textContent = 'Download PDF';
            pdfWindow.document.body.replaceChildren(frame, fallback);
        }
    }
    setTimeout(() => URL.revokeObjectURL(url), 60000);
};
export const openOrDownloadPdf = async (base64, fileName, title = fileName) => {
    // Decode via the browser's native data-URI parser rather than manual atob/Uint8Array
    // reconstruction — the manual path is prone to subtle corruption on large payloads.
    const response = await fetch(`data:application/pdf;base64,${base64}`);
    const blob = await response.blob();
    openOrDownloadBlob(blob, fileName, title);
};
